import moment from 'helpers/dayjsWrapper';
import styled from 'styled-components';
import Button from 'components/_parts/atoms/button';
import { PropsGetJobLevel } from 'components/types/company';

const ButtonEdit = styled(Button)`
  width: 100%;
  max-width: 70px;
  height: 24px;
  float: right;
`;

function ActionCell({ t, onClick }) {
  return (
    <ButtonEdit icon="edit" func={onClick}>
    &nbsp;&nbsp;
      {t('org.structure_view.modal.edit')}
    </ButtonEdit>
  );
}

const getJobLevelColumns = ({
  t, handleClickAction,
} : PropsGetJobLevel) => [
  {
    name: t('org.job_lvl.lvl'),
    sortField: true,
    selector: (row) => row.level ?? '-',
    center: true,
    width: '15%',
  },
  {
    name: t('org.job_lvl.job_lvl_name'),
    sortField: true,
    width: '35%',
    selector: (row) => row.name,
  },
  {
    name: t('org.job_lvl.updated'),
    sortField: true,
    selector: (row) => moment(row.updated_at || row.created_at).format('D MMM YYYY') ?? '-',
    center: true,
    width: '25%',
  },
  {
    name: t('wla.status.table.status'),
    sortField: true,
    width: '13%',
    selector: (row) => row.status_ket,
  },
  {
    name: t('org.employee.action'),
    sortField: true,
    style: {
      justifyContent: 'center',
    },
    center: true,
    selector: () => 'der',
    width: '12%',
    cell: (row) => <ActionCell t={t} onClick={() => handleClickAction(row)} />,
  },
];

export default getJobLevelColumns;
